module.exports = __webpack_public_path__ + "img/Vordach.bd20f1ea.jpg";